/**
 * Search the first and should be the unique payment active of an array
 * if exist return the payment.
 * If not, return false.
 */
export const searchPaymentActive = (arrayPayments: string[]): string | undefined =>
    arrayPayments.find((el) => el[8] === "active") 